const resetPassword = {
  resetPasswordTitle: 'Restablecer su contraseña',
  resetNotSuccess: 'Algo salió mal Intente de nuevo o comuníquese con michael@moovex.com',
  resetPasswordBtn: 'Continuar',
  resetPasswordHint: 'Introduzca una nueva contraseña.',
  resetSuccessful: 'Ha cambiado correctamente su contraseña.',
  backToLogIn: 'Por favor, vuelva a iniciar sesión y vuelva a iniciar sesión',
  newPassword: 'Nueva contraseña',
  reEnterPassword: 'Confirme su contraseña',
};

export default resetPassword;
